module.exports = __webpack_public_path__ + "img/img_qrcode.12edbdbc.jpg";